module.exports = __webpack_public_path__ + "static/logo3-700b4bc37ec29b36158eff6c765568db.png";